export { syntaxHighlight } from './highlight'
